<template>
    <div class="header" ref="header" :class="{stopScroll:cloakShow}">
        <transition name="component-fade" mode="out-in">
            <div class="index-tabs active" ref="tabs" v-if="lang" key="zh">
                <router-link to="./" style="text-decoration: none">
                    <div class="index-tabs-logoName" :style="{color:listTextColor,marginLeft:pcShow?'10vw':'3.5vw'}">
                        <img v-show="$i18n.locale==='zh'" class="index-tabs-logoName-img" src="../../assets/赛德部落.png" alt="">
                        <img v-show="$i18n.locale!=='zh'" class="index-tabs-logoName-img" src="../../assets/ThirdPole.png" alt="">
                    </div>
                </router-link>
                <div class="lists">
                    <div class="index-tabs-list" :key="index" v-for="(list,index) in lists"
                    >
                        <a @click="pcRoute(list.address)">
                            {{ $t(`${list.des}`)}}
                        </a>
                    </div>
                    <div class="index-tabs-list"
                         @mouseenter="menuShow=true"
                         @mouseleave="menuShow=false"
                         key="10">
                        <p style="color: white">{{$i18n.locale==='zh'?'English':'中文'}}</p>
                        <transition name="slide"
                                    @before-enter="beforeEnter"
                                    @enter="enter"
                                    @before-leave="beforeLeave"
                                    @leave="leave"
                        >
                            <div class="menu"
                                 v-show="menuShow"
                            >
                                <div
                                        @click="languageToggle($i18n.locale==='zh'?'zh':'en')"
                                        @mouseenter="addActive"
                                        @mouseleave="removeActive"
                                >{{$i18n.locale==='zh'?'中文':'English'}}</div>
                                <div
                                        @click="languageToggle($i18n.locale!=='zh'?'zh':'en')"
                                        @mouseenter="addActive"
                                        @mouseleave="removeActive"
                                >{{$i18n.locale!=='zh'?'中文':'English'}}</div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
            <div class="index-tabs active" ref="tabs" v-if="!lang" key="en">
                <div class="index-tabs-logoName" :style="{color:cloakShow?'white':''}" style="margin-left: 10vw">
                    <img v-show="$i18n.locale==='zh'" class="index-tabs-logoName-img" src="../../assets/赛德部落.png" alt="">
                    <img v-show="$i18n.locale!=='zh'" class="index-tabs-logoName-img" src="../../assets/ThirdPole.png" alt="">
                </div>
                <div class="lists">
                    <div class="index-tabs-list" :key="index" v-for="(list,index) in lists">
                        <a @click="pcRoute(list.address)">
                            {{ $t(`${list.des}`)}}
                        </a>
                    </div>
                    <div class="index-tabs-list"
                         @mouseenter="menuShow=true"
                         @mouseleave="menuShow=false"
                         key="10">
                        <p style="color: white">{{$i18n.locale==='zh'?'English':'中文'}}</p>
                        <transition name="slide"
                                    @before-enter="beforeEnter"
                                    @enter="enter"
                                    @before-leave="beforeLeave"
                                    @leave="leave"
                        >
                            <div class="menu"
                                 v-show="menuShow"
                            >
                                <div
                                        @click="languageToggle($i18n.locale==='zh'?'zh':'en')"
                                        @mouseenter="addActive"
                                        @mouseleave="removeActive"
                                >{{$i18n.locale==='zh'?'中文':'English'}}</div>
                                <div
                                        @click="languageToggle($i18n.locale!=='zh'?'zh':'en')"
                                        @mouseenter="addActive"
                                        @mouseleave="removeActive"
                                >{{$i18n.locale!=='zh'?'中文':'English'}}</div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </transition>
        <x-icon name="list" class="listIcon" color="white" @click="cloakToggle">
        </x-icon>
        <transition name="fade">
            <div class="listsCloak" v-show="cloakShow" @click="closeCloak('listCloak')"></div>
        </transition>
        <div class="listsCloakItem" v-show="cloakShow">
            <div
                    :style="{transitionDelay:`${index/15}s`}"
                    class="listsCloakItem-list"
                    :class="{active:langSwitch}"
                    v-for="(list,index) in lists" :key="index" ref="list">
                <a @click="phoneRoute(list.address)">
                    {{ $t(`${list.des}`)}}
                </a>
            </div>
        </div>
        <x-switch style="position: absolute;top: 80vh;right: 10px;" :father-toggle="tellChildBoolean"
                  :class="{active:cloakShow}" class="listsCloakItem-list" @on-change="languageToggle"
                  inactive-color="#f8b01a">
            <span slot="open">En</span>
            <span slot="close">中</span>
        </x-switch>
    </div>
</template>
<script>
    import Switch from '../../components/switch/switch'
    import Icon from '../../components/icon/icon'
    import {isPC,findRoot} from "../../utils/methods";
    import BScroll from "@better-scroll/core";
    export default {
        name: "Header",
        components: {
            'x-switch': Switch,
            'x-icon': Icon
        },
        props:{
            scrollTops:Object
        },
        computed: {
            listTextColor() {
                if (this.isSpecialPage) return 'white'
                return this.cloakShow ? 'white' : ''
            },
            tellChildBoolean(){
                return this.$i18n.locale==='zh'
            }
        },
        data() {
            return {
                lang: true,
                cloakShow: false,
                pcShow: false,
                langSwitch: false,
                isSpecialPage: false,
                menuShow:false,
                menuDivActive:false,
                lists: [
                    {des: 'navBar.home', address: '/#home'},
                    {des: 'navBar.serve', address: '/#product'},
                    {des: 'navBar.exhibition', address: '/#exhibition'},
                    {des: 'navBar.contact', address: '/#about'},
                ],
                bs:{},
                maxY:0
            }
        },
        mounted() {
            this.pcShow = isPC()
            if(!this.pcShow){
                this.useBs()
                findRoot(this,this.bs,'bs')
            }
            this.showAddActive()
            this.stopMove()
            if(!this.pcShow){
                this.anchorPoint()
            }
            this.$i18n.locale = sessionStorage.getItem('lang')||'zh'

        },
        beforeDestroy(){
            if(!isPC()){
                this.bs.destroy()
            }
        },
        methods: {
            pcRoute(address){
                let name = address.slice(2)
                if(this.$route.path==='/'){
                    document.querySelector('#app').scrollTop = this.scrollTops[name]
                    this.$router.push({path:`./#${name}`})
                }else{
                    this.$router.push({path:`./#${name}`})
                    window.requestAnimationFrame(()=>{
                        document.querySelector('#app').scrollTop = JSON.parse(sessionStorage.getItem('offsetTop'))[name]
                    })
                }
            },
            anchorPoint(){
                let name = this.$route.fullPath.slice(2)
                if(this.$route.fullPath.slice(1,2)==='#'&&name!=='home'){
                    window.requestAnimationFrame(()=>{
                        this.bs.scrollTo(this.bs.x,-JSON.parse(sessionStorage.getItem('offsetTop'))[name],0)
                    })
                }
            },
            phoneRoute(address){
                document.body.style.position = ''
                let name = address.slice(2)
                this.cloakToggle()
                window.requestAnimationFrame(()=>{
                    if(this.$route.path==='/'){
                        this.bs.scrollTo(this.bs.x,-this.scrollTops[name],0)
                        this.$router.push({path:`./#${name}`})
                    }else{
                        this.$router.push({path:`./#${name}`})
                    }
                    this.cloakShow = false
                    setTimeout(() => {
                        this.langSwitch = this.cloakShow
                    }, 25)
                })
            },
            beforeEnter(el) {
                el.style.height = 0
                el.style.overflow = 'hidden'
            },
            enter(el) {
                setTimeout(()=>{
                    el.style.height = ''
                })
            },
            beforeLeave(el) {
                el.style.height = ''
                el.style.overflow = 'hidden'
            },
            leave(el) {
                setTimeout(()=>{
                    el.style.height = 0
                })
            },
            stopMove(){
                if(this.cloakShow){
                    this.bs.maxScrollY = 0
                }else{
                    this.bs.maxScrollY = this.maxY
                }
            },
            cloakToggle(elName) {
                if(elName==='listCloak'&&!this.cloakShow)return
                this.cloakShow = !this.cloakShow
                findRoot(this,this.cloakShow,'cloakShow')
                this.stopMove()
                if (this.$parent.$el.id === 'home') {
                    this.$parent.cloakShow = this.cloakShow
                }
                setTimeout(() => {
                    this.langSwitch = this.cloakShow
                }, 25)
            },
            addActive(e){
                e.target.classList.add('active')
            },
            removeActive(e){
                e.target.classList.remove('active')
            },
            closeCloak(elName){
                this.cloakToggle(elName)
            },
            languageToggle(lang) {
                clearTimeout(this.timer)
                this.langSwitch = false
                this.timer = setTimeout(() => {
                    this.$i18n.locale = isPC() ? lang : lang ? 'zh' : 'en';
                    this.langSwitch = true
                    this.lang = !this.lang
                    sessionStorage.setItem('lang',this.$i18n.locale);
                }, this.pcShow ? 0 : 650)
            },
            showAddActive() {
                this.$refs.tabs&&this.$refs.tabs.classList.remove('active')
                setTimeout(() => {
                    this.$refs.tabs.classList.add('active')
                }, 300)
            },
            useBs(){
                if(this.pcShow)return
                if(Object.keys(this.bs).length>0){
                    this.bs.destroy()
                }
                this.bs = new BScroll(document.querySelector('#app'), {
                    scrollY: true,
                    click: true,
                    probeType: 3
                })
                this.maxY = this.bs.maxScrollY
            }

        },
    }
</script>

<style scoped lang="scss" src="./header.scss"></style>
